<template>
  <div class="visual-element-image">
    <FormVisualElement class="col-1/2" @valid="$emit('valid', $event)">
      <FormRow
        label="Seleziona un'immagine"
        legend="(dimensioni suggerite - 16/9: 750x422px, quadrata: 750x750px, fullscreen: 750x1334px)"
        :for-id="`visual-element-image-${_id}`"
        name="Immagine"
        rules="required"
        :legend-block="true"
      >
        <v-image-input
          :id="`visual-element-image-wide-${_id}`"
          :podcastId="podcastId"
          :imageWidth="750"
          :imageHeight="422"
          name="image"
          v-model="modelDataElement.src"
          :isVisualElement="true"
          label="Carica foto 16:9"
          @img_size="updateSizes"
        />
        <div class="mt-2" />
        <v-image-input
          :id="`visual-element-image-squared-${_id}`"
          :podcastId="podcastId"
          :imageWidth="750"
          :imageHeight="750"
          name="image"
          v-model="modelDataElement.src"
          :hide-image="true"
          label="Carica foto 1:1"
          @img_size="updateSizes"
        />
        <div class="mt-2" />
        <v-image-input
          :id="`visual-element-image-fullscreen-${_id}`"
          :podcastId="podcastId"
          :imageWidth="750"
          :imageHeight="1334"
          name="image"
          v-model="modelDataElement.src"
          :hide-image="true"
          label="Carica foto fullscreen"
          @img_size="updateSizes"
        />

        <div class="mt-2" />
        <v-image-input
          v-model="modelDataElement.src"
          :id="`visual-element-image-wide-gif-${_id}`"
          :podcastId="podcastId"
          :imageWidth="750"
          :imageHeight="422"
          :hide-image="true"
          label="Carica GIF 16:9"
          :disable-crop="true"
          @img_size="updateSizes"
        />

        <div class="mt-2" />
        <v-image-input
          v-model="modelDataElement.src"
          :id="`visual-element-image-squared-gif-${_id}`"
          :podcastId="podcastId"
          :imageWidth="750"
          :imageHeight="750"
          :hide-image="true"
          label="Carica GIF quadrata"
          :disable-crop="true"
          @img_size="updateSizes"
        />

        <div class="mt-2" />
        <v-image-input
          v-model="modelDataElement.src"
          :id="`visual-element-image-fullscreen-gif-${_id}`"
          :podcastId="podcastId"
          :imageWidth="750"
          :imageHeight="1334"
          :hide-image="true"
          label="Carica GIF fullscreen"
          :disable-crop="true"
          @img_size="updateSizes"
        />
      </FormRow>

      <template v-if="modelDataElement.src && modelDataElement.src !== ''">
        <FormRow
          label="Informazioni sull’autore"
          legend="(facoltativa)"
          :for-id="`visual-element-image-autor-${_id}`"
          name="Informazioni sull’autore"
        >
          <v-input
            :id="`visual-element-image-autor-${_id}`"
            type="text"
            name="author"
            v-model="modelDataElement.author"
          />
        </FormRow>

        <FormRow
          label="Altre informazioni"
          legend="(facoltativa)"
          :for-id="`visual-element-image-text-${_id}`"
          name="Altre informazioni"
        >
          <v-medium-editor
            :id="`visual-element-image-text-${_id}`"
            name="quote"
            v-model="modelDataElement.text"
          />
        </FormRow>
      </template>
    </FormVisualElement>
  </div>
</template>

<script>
/** Components */
import VisualElementBase from '@/components/VisualElementBase.vue'

export default {
  extends: VisualElementBase,

  defaultContent: {
    src: '',
    width: 0,
    height: 0,
  },

  data() {
    return {
      updateLoading: false,
    }
  },
  methods: {
    updateSizes(sizes) {
      this.modelDataElement.width = sizes[0]
      this.modelDataElement.height = sizes[1]
    },
  },
}
</script>

<style lang="scss" scoped>
.hide-img > img {
  display: none;
}
</style>
